import {
  removeNull,
  getSameAttribute,
  getLevelArray,
  sortArray,
  sortBy
} from '@/utils/handleData.js'
import { daysFormat } from '@/filters/index'
export default {
  namespaced: true,
  state: {
    checkReport: [],
    useReport: [],
    goods: [],
    curCheckReport: {}, // 当前物资验收单信息
    curUseReport: {}, // 当前物资领用单信息
    goodsInbound: [], // 入库明细
    goodsOutbound: [], // 出库明细
    goodsList: [], // 缓存安全物资出入库列表
    checkDetails: [],
    receiptList: []
  },
  getters: {
    compileOutbound: (state) => {
      var compileOutbound = JSON.parse(JSON.stringify(state.goodsOutbound))
      var data = {
        uid: 'inboundUid',
        label: 'inboundDate',
        childUid: 'uid',
        childLabel: 'inboundDate',
        sumKeys: ['useQuantity', 'useAmount'],
        keepKeys: [
          'goods',
          'goodsNo',
          'model',
          'unit',
          'price',
          'goodsType',
          'inboundQuantity',
          'totalUsed',
          'inboundDate'
        ]
      }
      compileOutbound = getLevelArray(compileOutbound, data)
      compileOutbound.forEach((item, index) => {
        item.uid = item.uid + index
        if (item.children.length === 1) {
          compileOutbound[index] = item.children[0]
        } else {
          item.children.forEach((child, num) => {
            child.label = '批次' + (num + 1)
          })
        }
      })
      data = {
        uid: 'goodsNo',
        label: 'goods',
        childUid: 'uid',
        childLabel: 'inboundDate',
        sumKeys: ['inboundQuantity', 'totalUsed', 'useQuantity', 'useAmount'],
        keepKeys: ['goods', 'model', 'unit', 'price', 'goodsType']
      }
      compileOutbound = getLevelArray(compileOutbound, data)
      compileOutbound = sortArray(compileOutbound, ['uid'])
      return compileOutbound
    },
    goodsLevelList: (state) => {
      var goodsLevelList = JSON.parse(JSON.stringify(state.goodsList))
      var params = {
        uid: 'goodsNo',
        label: 'label',
        childUid: 'uid',
        childLabel: 'inboundDate',
        sumKeys: [
          'checkQuantity',
          'unqualified',
          'inboundQuantity',
          'totalUsed',
          'theoreticalInventory'
        ],
        keepKeys: ['goodsNo', 'goodsName', 'model', 'unit']
      }
      goodsLevelList = getLevelArray(goodsLevelList, params)
      if (goodsLevelList.length) {
        goodsLevelList.forEach((item) => {
          item.showButtons = false
          item.goodsTypes =
            item.children[0].goodsType[item.children[0].goodsType.length - 1]
          params = {
            uid: 'supplierGoods',
            label: 'supplier',
            childUid: 'uid',
            childLabel: 'inboundDate',
            sumKeys: [
              'checkQuantity',
              'unqualified',
              'inboundQuantity',
              'totalUsed',
              'theoreticalInventory'
            ],
            keepKeys: ['unit']
          }
          item.children = getLevelArray(item.children, params)
          let needCheckNum = 0
          let needGenerateNum = 0
          item.children.forEach((child) => {
            child.showButtons = false
            let needCheck = child.children.filter((inbound) => {
              return inbound.checkResult === '1'
            })
            let noCheckReport = child.children.filter((inbound) => {
              return !inbound.checkReportUid
            })
            child.checkStatus = needCheck.length + '条待试验抽检'
            child.checkReportNo = noCheckReport.length + '条待生成'
            needCheckNum = needCheckNum + needCheck.length
            needGenerateNum = needGenerateNum + noCheckReport.length
          })
          item.checkStatus = needCheckNum + '条待试验抽检'
          item.checkReportNo = needGenerateNum + '条待生成'
        })
        goodsLevelList = goodsLevelList.sort(sortBy(['goodsTypes']))
      }
      return goodsLevelList
    }
  },
  mutations: {},
  actions: {
    // 获取全部物资信息
    async getGoods({ commit, dispatch }) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'GET',
          url: '/organize/goods/dicname'
        },
        { root: true }
      )
      // console.log(res)
      var goods = res.data ? res.data.sort(sortBy(['goodsNo'])) : []
      goods.forEach((item, index) => {
        item.value = item.goodsNo + index
        item.label =
          item.goodsNo +
          '\xa0\xa0' +
          item.goodsName +
          (item.model ? '\xa0/\xa0' + item.model : '')
      })
      commit(
        'baseSet',
        {
          module: 'material',
          key: 'goods',
          value: goods
        },
        { root: true }
      )
    },
    // 获取物资验收单
    async getCheckReport({ rootState, commit, dispatch }, data) {
      if (!data) {
        await dispatch(
          'bidSection/ensureDefaultBidQuery',
          { queryKey: 'checkReports', fieldKey: 'projectUid' },
          { root: true }
        )
      }
      var queryValues = {
        orgUid: data ? data.orgUid : rootState.user.orgValue,
        projectUid: !data
          ? rootState.queryValues.checkReports.projectUid
          : data.projectUid
          ? data.projectUid
          : data.orgUid
      }
      if (rootState.currentStep.theme === 'safetyInput') {
        queryValues.useType = '安全物资采购'
      } else {
        queryValues.useType = ''
      }
      const res = await dispatch(
        'baseRequest',
        {
          method: 'GET',
          url: '/organize/temp/safefundaccount',
          data: queryValues
        },
        { root: true }
      )
      // console.log(res.data)
      var checkReport = res.data ? res.data : []
      checkReport.forEach((item) => {
        item.checkReport = JSON.parse(JSON.stringify(item))
        item.checkReportUid = item.uid
        item.useDate = daysFormat(item.useDate)
        item.investAmount = item.investAmount ? item.investAmount : 0
        item.disabledButtons = []
        if (rootState.user.orgValue !== item.orgUid) {
          item.disabledButtons = [0, 1, 2]
        }
        if (item.useDetails) {
          item.useDetails.forEach((child) => {
            child.measuredAmount = child.measuredAmount
              ? child.measuredAmount
              : 0
            child.measureState = !child.measuredAmount
              ? '未计量'
              : child.expenseAmount === child.measuredAmount
              ? '全部计量'
              : '部分计量'
            child.fundType =
              child.expenseName + '：\xa0' + child.expenseAmount + '元'
          })
        }
        item.measuredAmount = getSameAttribute(
          item.useDetails,
          'measuredAmount'
        ).addValue
        item.measureState = !item.isMeasured
          ? '未计量'
          : !item.measuredAmount
          ? '计量审核中'
          : item.expenseAmount === item.measuredAmount
          ? '全部计量'
          : '部分计量'
        item.fundType = getSameAttribute(
          item.useDetails,
          'fundType',
          '。\n'
        ).joinString
        item.hasInvoice = item.invoiceImg ? '是' : '否'
        item.otherEnclosure = item.otherEnclosure ? item.otherEnclosure : []
        commit(
          'pictureSet',
          { key: 'invoiceImg', value: [item.invoiceImg] },
          { root: true }
        )
        commit(
          'pictureSet',
          { key: 'otherEnclosure', value: item.otherEnclosure },
          { root: true }
        )
        item.fileLists = {
          invoiceImg: rootState.pictures.invoiceImg,
          otherEnclosure: rootState.pictures.otherEnclosure
        }
        let srcList = []
        srcList = srcList.concat(
          item.fileLists.invoiceImg,
          item.fileLists.otherEnclosure
        )
        item.srcList = getSameAttribute(srcList, 'url').values
        item.detailForm = [
          { prop: 'accountNum', label: '台帐编号', value: item.accountNum },
          {
            prop: 'useReason',
            label: '使用缘由',
            value: item.useReason,
            span: 10
          },
          { prop: 'useDate', label: '使用时间', value: item.useDate },

          {
            prop: 'useAmount',
            label: '使用金额(元)',
            value: item.useAmount,
            span: 4
          },
          {
            prop: 'useDepartment',
            label: '使用部门',
            value: item.useDepartment,
            span: 5
          },
          { prop: 'usePerson', label: '领用人', value: item.usePerson },
          { prop: 'approver', label: '审批人', value: item.approver },
          {
            prop: 'useType',
            label: '使用类型',
            value: item.useType
          },
          {
            prop: 'hasInvoice',
            label: '是否有发票',
            value: item.hasInvoice,
            span: 4
          },
          {
            prop: 'invoiceImg',
            label: '发票图片',
            value: item.invoiceImg ? item.invoiceNo : '暂无发票',
            drillDown: true,
            span: 5
          },
          {
            prop: 'otherEnclosure',
            label: '其他附件',
            value: item.fileLists.otherEnclosure.length + '个附件',
            drillDown: true
          },
          {
            prop: 'checkReportNo',
            label: '物资验收单编号',
            value: item.checkReportNo,
            drillDown: true,
            span: 14
          }
        ]
      })
      if (!data && rootState.queryValues.checkReports.hasInvoice) {
        checkReport = checkReport.filter((item) => {
          return queryValues.hasInvoice === '是'
            ? item.invoiceImg
            : !item.invoiceImg
        })
      }
      if (!data && rootState.queryValues.checkReports.query) {
        checkReport = checkReport.filter((item) => {
          return (
            item.checkReportNo.includes(
              rootState.queryValues.checkReports.query
            ) ||
            item.useDepartment.includes(
              rootState.queryValues.checkReports.query
            ) ||
            item.usePerson.includes(rootState.queryValues.checkReports.query)
          )
        })
      }
      if (
        !data &&
        rootState.queryValues.checkReports.checkDate &&
        rootState.queryValues.checkReports.checkDate.length
      ) {
        checkReport = checkReport.filter((item) => {
          return (
            item.useDate >= rootState.queryValues.checkReports.checkDate[0] &&
            item.useDate <= rootState.queryValues.checkReports.checkDate[1]
          )
        })
      }
      commit(
        'baseSet',
        {
          module: 'material',
          key: 'checkReport',
          value: checkReport
        },
        { root: true }
      )
    },
    // 新增物资验收单
    async addCheckReport({ dispatch }, data) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'POST',
          url: '/organize/temp/safefundaccount',
          data: data,
          msg: '添加物资验收单成功'
        },
        { root: true }
      )
      return res
    },
    // 编辑安全经费使用台帐
    async editCheckReport({ dispatch }, data) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'PUT',
          url: '/organize/temp/safefundaccount',
          data: data,
          msg: '编辑物资验收单成功'
        },
        { root: true }
      )
      return res
    },
    // 删除安全经费使用台帐
    async deleteCheckReport({ dispatch }, uid) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'DELETE',
          url: '/organize/temp/safefundaccount',
          data: { uid: uid },
          msg: '删除物资验收单成功'
        },
        { root: true }
      )
      return res
    },
    // 获取物资出入库列表
    async getGoodsList({ rootState, commit, dispatch }, data) {
      const stepName = rootState.currentStep.step.slice(0, -4)
      if (!data) {
        await dispatch(
          'bidSection/ensureDefaultBidQuery',
          { queryKey: stepName, fieldKey: 'projectUid' },
          { root: true }
        )
      }
      var queryValues = {
        orgUid: data ? data.orgUid : rootState.user.orgValue,
        checkReportUid: data
          ? data.checkReportUid
          : rootState.queryValues[stepName].checkReportUid,
        receiptUid: data
          ? data.receiptUid
          : rootState.queryValues[stepName].receiptUid,
        projectUid: !data
          ? rootState.queryValues[stepName].projectUid
          : data.projectUid
          ? data.projectUid
          : data.orgUid,
        goodsType: !data
          ? rootState.queryValues[stepName].goodsType
          : typeof data.goodsType !== 'string'
          ? ''
          : data.goodsType,
        query: data ? data.query : rootState.queryValues[stepName].query
      }
      queryValues = removeNull(queryValues)
      const res = await dispatch(
        'baseRequest',
        {
          method: 'GET',
          url: '/organize/goods/receiptdetailcontent',
          data: queryValues
        },
        { root: true }
      )
      //console.log(res)
      var goodsList = res.data ? res.data : []
      goodsList.forEach((item) => {
        item.inboundUid = item.uid
        item.label = item.goodsNo + '\xa0\xa0' + item.goodsName
        item.goodsTypes = item.model
        item.goods = item.label
        item.supplierGoods = item.goodsNo + item.supplier
        item.inboundAmount =
          item.price && item.inboundQuantity
            ? parseFloat(item.inboundQuantity * item.price).toFixed(2)
            : 0
        item.checkStatus = rootState.dictionarys.checkResult.find((result) => {
          return result.value === item.checkResult
        }).label
        item.acceptanceStatus = {
          '0': '验收合格',
          '1': '待送检',
          '2': '有不合格品',
          '3': '验收合格'
        }[item.checkResult] || ''
        item.checkInfo =
          item.inboundDate && item.checkPerson && item.checkStatus
            ? item.inboundDate +
              '\xa0现场验收；验收人：' +
              item.checkPerson +
              '；验收结果：' +
              item.checkStatus +
              '；验收附件' +
              (item.checkContent && item.checkContent.length
                ? item.checkContent.length
                : 0) +
              '个'
            : ''
        item.checkReportNo = item.checkReportNo ? item.checkReportNo : '未生成'
        item.receiptNo = item.receiptNo ? item.receiptNo : '未生成'
        item.checkContent = item.checkContent ? item.checkContent : []
        commit(
          'pictureSet',
          { key: 'checkContent', value: item.checkContent },
          { root: true }
        )
        item.fileLists = {
          checkContent: rootState.pictures.checkContent
        }
        item.srcList = getSameAttribute(
          item.fileLists.checkContent,
          'url'
        ).values
        item.totalUsed =
          item.useDetails && item.useDetails.length
            ? getSameAttribute(item.useDetails, 'useQuantity').addValue
            : 0
        item.theoreticalInventory = item.inboundQuantity - item.totalUsed
      })
      goodsList = goodsList.sort(sortBy(['goodsTypes']))
      if (!data && rootState.queryValues[stepName].supplier) {
        goodsList = goodsList.filter((item) => {
          return item.supplier.includes(
            rootState.queryValues[stepName].supplier
          )
        })
      }
      if (!data && rootState.queryValues[stepName].hasCheckReport) {
        goodsList = goodsList.filter((item) => {
          return rootState.queryValues[stepName].hasCheckReport === '是'
            ? item.checkReportUid
            : !item.checkReportUid
        })
      }
      if (
        !data &&
        rootState.queryValues[stepName].inboundDate &&
        rootState.queryValues[stepName].inboundDate.length
      ) {
        goodsList = goodsList.filter((item) => {
          return (
            item.inboundDate >=
              rootState.queryValues[stepName].inboundDate[0] &&
            item.inboundDate <= rootState.queryValues[stepName].inboundDate[1]
          )
        })
      }
      commit(
        'baseSet',
        {
          module: 'material',
          key: 'goodsList',
          value: goodsList
        },
        { root: true }
      )
      if (queryValues.checkReportUid) {
        const goodsInbound = JSON.parse(JSON.stringify(goodsList))
        goodsInbound.forEach((item) => {
          const expenseName = rootState.dictionarys.securityFundType.find(
            (fundType) => {
              return fundType.defaultGoodsType === item.goodsType[1]
            }
          )
          item.securityFundType = expenseName
            ? expenseName.securityFundType
            : ''
          item.expenseName = expenseName ? expenseName.expenseName : ''
          item.fundTypes = expenseName
            ? [expenseName.securityFundType, expenseName.expenseName]
            : []
        })
        commit(
          'baseSet',
          {
            module: 'material',
            key: 'goodsInbound',
            value: goodsInbound
          },
          { root: true }
        )
      }
      if (queryValues.receiptUid) {
        commit(
          'baseSet',
          {
            module: 'material',
            key: 'goodsInbound',
            value: JSON.parse(JSON.stringify(goodsList))
          },
          { root: true }
        )
      }
    },
    // 新增物资入库明细
    async addGoodsInbound({ state, commit, dispatch }) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'POST',
          url: '/organize/goods/receiptdetail',
          data: state.goodsInbound,
          msg: '添加物资入库明细成功'
        },
        { root: true }
      )
      if (res.code === 200) {
        var goodsInbound = res.data ? res.data : []
        goodsInbound.forEach((item) => {
          item.goods = item.goodsNo + '\xa0\xa0' + item.goodsName
          item.fileLists = []
          item.fileLists.checkContent = []
        })
        dispatch('getGoods')
        commit(
          'baseSet',
          {
            module: 'material',
            key: 'goodsInbound',
            value: goodsInbound
          },
          { root: true }
        )
      }
      return res
    },
    // 编辑物资入库明细
    async editGoodsInbound({ state, dispatch }, data) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'PUT',
          url: '/organize/goods/receiptdetail',
          data: data ? data : state.goodsInbound,
          msg: '编辑物资入库明细成功'
        },
        { root: true }
      )
      return res
    },
    // 删除物资入库明细
    async deleteGoodsInbound({ dispatch }, uid) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'DELETE',
          url: '/organize/goods/receiptdetail',
          data: { uid: uid },
          msg: '删除物资入库明细成功'
        },
        { root: true }
      )
      return res
    },
    // 获取物资领用单
    async getUseReport({ rootState, commit, dispatch }, data) {
      if (!data) {
        await dispatch(
          'bidSection/ensureDefaultBidQuery',
          { queryKey: 'useReports', fieldKey: 'projectUid' },
          { root: true }
        )
      }
      var queryValues = {
        orgUid: data ? data.orgUid : rootState.user.orgValue,
        projectUid: !data
          ? rootState.queryValues.useReports.projectUid
          : data.projectUid
          ? data.projectUid
          : data.orgUid
      }
      queryValues = removeNull(queryValues)
      const res = await dispatch(
        'baseRequest',
        {
          method: 'GET',
          url: '/organize/goods/receives',
          data: queryValues
        },
        { root: true }
      )
      //console.log(res.data)
      var useReport = res.data ? res.data : []
      useReport.forEach((item) => {
        item.subitemCN = item.subitemCode + '\xa0' + item.subitemName
        item.usePhotos = item.usePhotos ? item.usePhotos : []
        commit(
          'pictureSet',
          { key: 'usePhotos', value: item.usePhotos },
          { root: true }
        )
        item.fileLists = {
          usePhotos: rootState.pictures.usePhotos
        }
        item.srcList = getSameAttribute(item.fileLists.usePhotos, 'url').values
      })
      if (!data && rootState.queryValues.useReports.usePosition) {
        useReport = useReport.filter((item) => {
          return item.usePosition.includes(
            rootState.queryValues.useReports.usePosition
          )
        })
      }
      if (!data && rootState.queryValues.useReports.query) {
        useReport = useReport.filter((item) => {
          return (
            item.usePosition.includes(rootState.queryValues.useReports.query) ||
            item.usePerson.includes(rootState.queryValues.useReports.query) ||
            item.grantPerson.includes(rootState.queryValues.useReports.query) ||
            item.useDepartment.includes(rootState.queryValues.useReports.query)
          )
        })
      }
      if (
        !data &&
        rootState.queryValues.useReports.useDate &&
        rootState.queryValues.useReports.useDate.length
      ) {
        useReport = useReport.filter((item) => {
          return (
            item.useDate >= rootState.queryValues.useReports.useDate[0] &&
            item.useDate <= rootState.queryValues.useReports.useDate[1]
          )
        })
      }
      commit(
        'baseSet',
        {
          module: 'material',
          key: 'useReport',
          value: useReport
        },
        { root: true }
      )
    },
    // 新增物资领用单
    async addUseReport({ state, rootState, commit, dispatch }, data) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'POST',
          url: '/organize/goods/receive',
          data: data,
          msg: '添加物资领用单成功'
        },
        { root: true }
      )
      if (res.code === 200) {
        const curUseReport = res.data ? res.data : {}
        curUseReport.usePhotos = curUseReport.usePhotos
          ? curUseReport.usePhotos
          : []
        commit(
          'pictureSet',
          { key: 'usePhotos', value: curUseReport.usePhotos },
          { root: true }
        )
        curUseReport.fileLists = {
          usePhotos: rootState.pictures.usePhotos
        }
        curUseReport.srcList = getSameAttribute(
          curUseReport.fileLists.usePhotos,
          'url'
        ).values
        commit(
          'baseSet',
          {
            module: 'material',
            key: 'curUseReport',
            value: curUseReport
          },
          { root: true }
        )
        const goodsOutbound = JSON.parse(JSON.stringify(state.goodsOutbound))
        goodsOutbound.forEach((item) => {
          res.data.useDetails.forEach((out) => {
            if (item.uid === out.lastUid) {
              item.uid = out.uid
            }
          })
        })
        commit(
          'baseSet',
          {
            module: 'material',
            key: 'goodsOutbound',
            value: goodsOutbound
          },
          { root: true }
        )
      }
      return res
    },
    // 编辑物资领用单
    async editUseReport({ dispatch }, data) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'PUT',
          url: '/organize/goods/receive',
          data: data,
          msg: '编辑物资领用单成功'
        },
        { root: true }
      )
      return res
    },
    // 删除物资领用单
    async deleteUseReport({ dispatch }, uid) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'DELETE',
          url: '/organize/goods/receive',
          data: { uid: uid },
          msg: '删除物资领用单成功'
        },
        { root: true }
      )
      return res
    },
    // 获取物资领用单明细
    async getGoodsOutbound({ state, commit, dispatch }, uid) {
      var useReportUid = uid ? uid : state.curUseReport.uid
      if (useReportUid) {
        const res = await dispatch(
          'baseRequest',
          {
            method: 'GET',
            url: '/organize/goods/receivedetail',
            data: { uid: useReportUid }
          },
          { root: true }
        )
        //console.log(res.data)
        var goodsOutbound = res.data ? res.data : []
        goodsOutbound.forEach((item) => {
          item.goods = item.goodsNo + '\xa0\xa0' + item.goodsName
          const sameInbound = goodsOutbound.filter((outbound) => {
            return item.inboundUid === outbound.inboundUid
          })
          item.totalUsed =
            item.totalUsed -
            getSameAttribute(sameInbound, 'useQuantity').addValue
          item.useAmount = parseFloat(item.useQuantity * item.price).toFixed(2)
        })
        commit(
          'baseSet',
          {
            module: 'material',
            key: 'goodsOutbound',
            value: goodsOutbound
          },
          { root: true }
        )
      }
    },
    // 编辑物资出库库明细
    async editGoodsOutbound({ state, dispatch }, data) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'PUT',
          url: '/organize/goods/receivedetail',
          data: data ? data : state.goodsOutbound,
          msg: '编辑物资出库明细成功'
        },
        { root: true }
      )
      return res
    },
    // 删除物资出库库明细
    async deleteGoodsOutbound({ dispatch }, uid) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'DELETE',
          url: '/organize/goods/receivedetail',
          data: { uid: uid },
          msg: '删除物资出库明细成功'
        },
        { root: true }
      )
      return res
    },
    // 获取物资验收单
    async getGoodsReceipt({ rootState, commit, dispatch }, data) {
      const queryValues = removeNull({
        orgUid: data && data.orgUid ? data.orgUid : rootState.user.orgValue,
        projectUid: data && data.projectUid ? data.projectUid : ''
      })
      const res = await dispatch(
        'baseRequest',
        {
          method: 'GET',
          url: '/organize/goods/receipt',
          data: queryValues
        },
        { root: true }
      )
      var receiptList = res.data ? res.data : []
      receiptList.forEach((item) => {
        item.receiptUid = item.uid
        item.useDate = daysFormat(item.useDate)
        item.useAmount = item.useAmount ? item.useAmount : 0
      })
      commit(
        'baseSet',
        { module: 'material', key: 'receiptList', value: receiptList },
        { root: true }
      )
    },
    // 新增物资验收单
    async addGoodsReceipt({ dispatch }, data) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'POST',
          url: '/organize/goods/receipt',
          data: data,
          msg: '生成物资验收单成功'
        },
        { root: true }
      )
      return res
    },
    // 编辑物资验收单
    async editGoodsReceipt({ dispatch }, data) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'PUT',
          url: '/organize/goods/receipt',
          data: data,
          msg: '编辑物资验收单成功'
        },
        { root: true }
      )
      return res
    },
    // 删除物资验收单
    async deleteGoodsReceipt({ dispatch }, uid) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'DELETE',
          url: '/organize/goods/receipt',
          data: { uid: uid },
          msg: '删除物资验收单成功'
        },
        { root: true }
      )
      return res
    }
  }
}
